import axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { Card, CardBody, CardImg, CardSubtitle } from 'reactstrap';
import HeroCardBody from './HeroCardBody';

function HeroCard({ id, title, image, isCarryTrade, forecastTerm }) {
  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/assets/${id}/forecasts?skip=0&limit=10`
      );
      if (response.status === 200) {
        setData(response.data);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }, [id]);

  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, [id, fetchData]);

  return (
    <Card className="center text-center" key={id}>
      <div className="container-img">
        <CardImg
          style={{ opacity: 0.35 }}
          top
          width="100%"
          src={image}
          alt={`${title} cover`}
        />
        <h4 className="centered mae-currency-name maeCurrencyName">
          {title}
        </h4>
      </div>

      {data && data.length > 0 ? (
        <HeroCardBody
          key={data[0].id}
          signal={data[0].signal}
          interest={data[0].interest}
          createdAt={data[0].date_of_forecast}
          exitedAt={data[0].date_of_exit}
          isCarryTrade={isCarryTrade}
          longCount={data[0].long_count}
          shortCount={data[0].short_count}
        />
      ) : (
        <CardBody className="no-data-card">
          <CardSubtitle>
            <h4>Coming Soon</h4>
          </CardSubtitle>
        </CardBody>
      )}
    </Card>
  );
}

export default HeroCard;
